import useRestService from '../shared/rest-service';
import BaseClient from '../models/base-client';
import { useQuery } from '@tanstack/react-query';

export function useClients() {
  const { fetchWrapper } = useRestService();
  return useQuery<{ results: BaseClient[]; totalItems: number }, Error>(['clients'], async () => {
    return fetchWrapper('api/clients?page=1&pageSize=0');
  });
}
